import axios, { AxiosRequestConfig, AxiosInstance } from 'axios';
import { getToken } from '../helpers/Token';
import robloxUrls from "../configs/roblox/robloxUrls";

interface ApiInterface extends AxiosInstance {
  oneSky?: any;
}

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  config.headers ||= {};
  config.headers['Content-Type'] = 'application/json';
  config.headers['Authorization'] = `Bearer ${getToken()}`;

  return config;
}

const mineCraftApi: ApiInterface = axios.create({ baseURL: robloxUrls.baseURL })
mineCraftApi.interceptors.request.use(onRequest);

mineCraftApi.oneSky = {
  url: robloxUrls.remoteUrl.bind(robloxUrls),
  uploadHeaders: {
    'Authorization': `Bearer ${getToken()}`
  }
}

export default mineCraftApi;
